import * as React from "react";
const SvgList = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871v5.252h5.252V1.871H4.498zM3.38 3.38h2.246v2.246H3.379V4.502Zm6.75.375v1.498H22.31V3.754h-6.092ZM1.87 9.369V14.63h5.252V9.37H4.498zm1.508 1.508h2.246v2.246H3.379V12Zm6.75.375v1.496H22.31v-1.496h-6.092ZM1.87 16.877v5.252h5.252v-5.252H4.498zm1.508 1.498h2.246v2.246H3.379v-1.123zm6.75.373v1.508H22.31v-1.508h-6.092Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgList;
